module.exports = __webpack_public_path__ + "static/media/nepali-flag.9ab1bc10.svg";